import { 
  Bold, Italic, Underline, 
  AlignLeft, AlignCenter, AlignRight, 
  List, ListOrdered, 
  Indent, Outdent,
  Eraser
} from 'lucide-react';
import { useUIStore } from '@/stores/uiStore';

export function EditorToolbar() {
  const toggleEmojiPicker = useUIStore(s => s.setEmojiPickerOpen);

  return (
    <div id="custom-toolbar" className="flex flex-wrap items-center gap-1 p-2 border-b border-border bg-background">
      {/* Headings */}
      <div className="flex items-center gap-1">
        <select className="ql-header h-8 w-24 px-2 text-sm border border-border rounded-md bg-card text-text-primary cursor-pointer" defaultValue="">
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="">Normal</option>
        </select>
      </div>
      
      <div className="w-px h-6 bg-border mx-2" />

      {/* Formatting */}
      <div className="flex items-center gap-0.5">
        <button className="ql-bold p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" title="Bold (Cmd+B)">
          <Bold className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-italic p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" title="Italic (Cmd+I)">
          <Italic className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-underline p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" title="Underline (Cmd+U)">
          <Underline className="w-4 h-4 text-text-primary" />
        </button>
      </div>

      <div className="w-px h-6 bg-border mx-2" />

      {/* Lists */}
      <div className="flex items-center gap-0.5">
        <button className="ql-list p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="ordered" title="Numbered List">
          <ListOrdered className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-list p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="bullet" title="Bullet List">
          <List className="w-4 h-4 text-text-primary" />
        </button>
      </div>

      <div className="w-px h-6 bg-border mx-2" />

      {/* Alignment */}
      <div className="flex items-center gap-0.5">
        <button className="ql-align p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="" title="Align Left">
          <AlignLeft className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-align p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="center" title="Align Center">
          <AlignCenter className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-align p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="right" title="Align Right">
          <AlignRight className="w-4 h-4 text-text-primary" />
        </button>
      </div>

      <div className="w-px h-6 bg-border mx-2" />

       {/* Indent */}
       <div className="flex items-center gap-0.5">
        <button className="ql-indent p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="-1" title="Outdent">
          <Outdent className="w-4 h-4 text-text-primary" />
        </button>
        <button className="ql-indent p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" value="+1" title="Indent">
          <Indent className="w-4 h-4 text-text-primary" />
        </button>
      </div>

      <div className="w-px h-6 bg-border mx-2" />

      {/* Extras */}
      <div className="flex items-center gap-0.5">
        <button className="ql-clean p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" title="Clear Formatting">
          <Eraser className="w-4 h-4 text-text-primary" />
        </button>
        {/* Custom Emoji Trigger */}
        <button type="button" className="p-1.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => toggleEmojiPicker(true)} title="Insert Emoji">
          <span className="text-sm">😊</span>
        </button>
      </div>
    </div>
  );
}
